var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_676_10071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19111 5.44397C7.38338 5.26086 7.69481 5.26086 7.88708 5.44397L17.7308 14.8189C17.9231 15.0021 17.9231 15.2987 17.7308 15.4818L15.762 17.3568C15.6659 17.4483 15.54 17.4941 15.414 17.4941C15.2881 17.4941 15.1622 17.4483 15.066 17.3568L5.22236 7.98181C5.03009 7.7987 5.03009 7.50209 5.22236 7.31897L7.19111 5.44397ZM15.4141 16.3625L16.6868 15.1504L10 8.782L8.72725 9.99416C8.72725 9.99413 15.4141 16.3625 15.4141 16.3625ZM8.03127 9.3313L9.30405 8.11913L7.53911 6.43824L6.26633 7.65041L8.03127 9.3313Z",
    fill: "#3876BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9844 6.24463C10.4922 5.30714 10 4.83839 9.01563 4.36963C9.99998 3.90087 10.4922 3.43214 10.9844 2.49463C11.4766 3.43211 11.9688 3.90087 12.9531 4.36963C11.9687 4.83839 11.4766 5.30714 10.9844 6.24463Z",
    fill: "#3876BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10939 9.05713C3.35547 9.52589 3.60165 9.76025 4.09375 9.99461C3.60155 10.229 3.35547 10.4634 3.10939 10.9321C2.86331 10.4633 2.6172 10.229 2.12503 9.99461C2.6172 9.76025 2.86328 9.52586 3.10939 9.05713Z",
    fill: "#3876BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10939 3.90087C3.84767 3.5493 4.21682 3.19775 4.58595 2.49463C4.9551 3.19775 5.32429 3.54933 6.0625 3.90087C5.32422 4.25245 4.95507 4.60399 4.58595 5.30711C4.21679 4.60399 3.84767 4.25242 3.10939 3.90087Z",
    fill: "#3876BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_676_10071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 15,
    fill: "white",
    transform: "matrix(-1 0 0 1 17.875 2.49414)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandIcon);
export default __webpack_public_path__ + "static/media/WandIcon.4832994f6cb3bff6d03c691a90c79e1e.svg";
export { ForwardRef as ReactComponent };